import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'avy-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {

@Input() label: string;

@Output() onLabel = new EventEmitter();

  constructor() { }

  ngOnInit() {
    console.log('My Name is :' + this.label);
  }


  setLabel(label: string){
    console.log('Button Comp - current label', label);
    this.onLabel.emit(label);
  }

}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/button/button.component.ts